import React, { Component } from 'react';
import { Button, Modal, ModalBody, ModalFooter} from "reactstrap";

// TODO taken from StacijaShow.js, did not refactor that file, should reduce duplication
class DeleteButton extends Component {
    constructor(props) {
        super(props);
        this.state = { modal: false };
    }

    setModal= (m) => () => {
        this.setState({ modal: m });
    };

    handleDelete = () => {
        this.setModal(false);
        this.props.deleteAct(this.props.rowId);
    };

    render() {
        return (
        <>
            <Button color="danger" outline size="sm" onClick={this.setModal(true)} disabled={this.props.disabled}>
            <i className="fa fa-trash-o"></i>
            </Button>
            <Modal isOpen={this.state.modal}>
            <ModalBody>{"Tiešām dzēst ierakstu?"}</ModalBody>
            <ModalFooter>
                <Button color="danger" onClick={this.handleDelete}>
                Dzēst
                </Button>{' '}
                <Button color="secondary" onClick={this.setModal(false)}>
                Atcelt
                </Button>
            </ModalFooter>
            </Modal>
        </>
        );
    }
}


export default (DeleteButton)
  